import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * React Router v6 stores a monotonic `idx` on `window.history.state`.
 * `idx > 0` means there is a prior SPA entry we can safely `navigate(-1)` to.
 */
export function canNavigateBackInApp(historyState: unknown): boolean {
  const idx = (historyState as { idx?: unknown } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
}

/**
 * Navigate back to the previous in-app history entry when available.
 * Falls back to `fallbackPath` for deep links / hard refresh (no prior SPA entry).
 */
export function useNavigateBack(fallbackPath: string): () => void {
  const navigate = useNavigate();

  return useCallback(() => {
    if (canNavigateBackInApp(window.history.state)) {
      navigate(-1);
      return;
    }
    navigate(fallbackPath);
  }, [navigate, fallbackPath]);
}
